import { useMomentumPilotAccess } from '../useMomentumPilotAccess';
import { TRANSCRIPTION_CONSENT_COPY_PILOT_KEY } from './constants';

export function useShowRefreshedTranscriptionConsentCopy(providerShortId: string | undefined): boolean {
  const { pilotAccess } = useMomentumPilotAccess(providerShortId ?? '', TRANSCRIPTION_CONSENT_COPY_PILOT_KEY);

  return pilotAccess?.enabled ?? false;
}
